import { Controller } from "@hotwired/stimulus"

// Handles the default visibility scope setting on the organization settings page.
// Shows/hides the org picker section when "SelectedOrganizations" is chosen,
// and listens for the org picker's selection event.
export default class extends Controller {
  static targets = ["select", "orgSection", "gidsField", "orgCount", "editLink"]

  declare readonly selectTarget: HTMLSelectElement
  declare readonly orgSectionTarget: HTMLElement
  declare readonly gidsFieldTarget: HTMLInputElement
  declare readonly orgCountTarget: HTMLElement
  declare readonly hasOrgSectionTarget: boolean
  declare readonly hasOrgCountTarget: boolean
  declare readonly hasEditLinkTarget: boolean
  declare readonly editLinkTarget: HTMLAnchorElement

  private handleOrgsSelected: (event: Event) => void

  connect() {
    this.handleOrgsSelected = this.onOrgsSelected.bind(this)
    window.addEventListener("visibility-orgs-selected", this.handleOrgsSelected)
    this.toggleOrgSection()
  }

  disconnect() {
    window.removeEventListener("visibility-orgs-selected", this.handleOrgsSelected)
  }

  onTypeChange() {
    this.toggleOrgSection()
  }

  private toggleOrgSection() {
    if (!this.hasOrgSectionTarget) return

    if (this.selectTarget.value === "SelectedOrganizations") {
      this.orgSectionTarget.classList.remove("hidden")
    } else {
      this.orgSectionTarget.classList.add("hidden")
    }
  }

  private onOrgsSelected(event: Event) {
    const { gids } = (event as CustomEvent).detail
    this.gidsFieldTarget.value = gids

    if (this.hasOrgCountTarget) {
      const count = gids.split(",").filter(Boolean).length
      this.orgCountTarget.textContent = `${count} organization${count === 1 ? "" : "s"} selected`
    }

    // Programmatic writes don't fire change; the auto-saving preferences form
    // needs one to persist the picker's selection.
    this.gidsFieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
  }

  openPicker() {
    if (!this.hasEditLinkTarget) return

    const url = new URL(this.editLinkTarget.href)
    url.searchParams.set("selected_gids", this.gidsFieldTarget.value)
    this.editLinkTarget.href = url.toString()
  }
}
